import hresh1xLabels from 'assets/labels/hresh1x'
import faker from 'faker'
import moment from 'moment'

export const mocker = {
  labels () {
    return {
      labels: hresh1xLabels
    }
  },
  index () {
    let mockRows = []
    const mockTotal = 5
    for (var i = 1; i <= mockTotal; i++) {
      mockRows.push({
        dtemistk: moment(faker.date.past()).format('DD/MM/YYYY'),
        desc_codpunsh: faker.random.words(),
        desc_typpun: faker.random.word(),
        dtestart: moment(faker.date.past()).format('DD/MM/YYYY'),
        dteend: moment(faker.date.past()).format('DD/MM/YYYY'),
        remark: 'Test',
        codpunsh: '',
        typpun: '',
        codempid: '',
        dteeffec: ''
      })
    }

    return {
      total: mockTotal,
      rows: mockRows
    }
  },
  detail () {
    let mockTab1 = {
      numhmref: faker.random.number(),
      dtemistk: moment(faker.date.past()).format('DD/MM/YYYY'),
      desc_refdoc: 'Test',
      desmist1: 'Test Description'
    }
    let mockTab2 = {
      numseq: faker.random.number().toString().substr(0, 1),
      codpunsh: faker.random.number(),
      desc_codpunsh: faker.random.words(),
      typpun: '',
      desc_typpun: 'ตัดเงินเดือน',
      dtestart: moment(faker.date.past()).format('DD/MM/YYYY'),
      dteend: moment(faker.date.past()).format('DD/MM/YYYY'),
      remark: 'Test remark',
      flgexempt: 'Y',
      codexemp: faker.random.number(),
      desc_codexemp: faker.random.words(),
      flgblist: 'Y',
      coduser: faker.name.findName(),
      dteupd: moment(faker.date.past()).format('DD/MM/YYYY')
    }
    let mockTab3 = {
      numprdst: faker.random.number().toString().substr(0, 1),
      dtemthst: moment().format('MMMM'),
      dteyearst: moment().format('YYYY'),
      numprden: faker.random.number().toString().substr(0, 1),
      dtemthen: moment().format('MMMM'),
      dteyearen: moment().format('YYYY'),
      codpay: faker.random.number(),
      desc_codpay: faker.random.words()
    }
    let mockTab3Rows = []
    const mockTab3Total = 5
    for (var i = 1; i <= mockTab3Total; i++) {
      mockTab3Rows.push({
        code: faker.random.number().toString().substr(0, 2),
        detail: faker.random.word(),
        unit: 'ต่อเดือน',
        amt: faker.commerce.price(),
        adjp: '',
        amtcded: faker.commerce.price(),
        amtded: '',
        amttotded: ''
      })
    }

    return {
      tab1: mockTab1,
      tab2: mockTab2,
      tab3: {
        detail: mockTab3,
        table: {
          total: mockTab3Total,
          rows: mockTab3Rows
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/hresh1x/mocker.js